import { doc, onSnapshot } from 'firebase/firestore';
import { db } from './config';

// Permisywne defaulty — gdy doc nie istnieje lub Firestore zwroci permission-denied,
// pokazujemy wszystkie metody loginu i nie filtrujemy domen. Lepsze niz zablokowanie
// userow przez brak configu.
export const DEFAULT_AUTH_SETTINGS = {
  googleEnabled: true,
  microsoftEnabled: true,
  microsoftTenantId: null,
  allowedEmailDomains: [],
};

export function subscribeToAuthSettings(callback) {
  const ref = doc(db, 'portalSettings', 'auth_config');
  return onSnapshot(
    ref,
    (snap) => {
      if (snap.exists()) {
        const data = snap.data();
        callback({
          googleEnabled: data.googleEnabled ?? DEFAULT_AUTH_SETTINGS.googleEnabled,
          microsoftEnabled: data.microsoftEnabled ?? DEFAULT_AUTH_SETTINGS.microsoftEnabled,
          microsoftTenantId: data.microsoftTenantId ?? null,
          allowedEmailDomains: Array.isArray(data.allowedEmailDomains) ? data.allowedEmailDomains : [],
        });
      } else {
        callback(DEFAULT_AUTH_SETTINGS);
      }
    },
    (err) => {
      console.warn('portalSettings/auth_config nie czyta sie — uzywam permisywnych defaultow', err.code);
      callback(DEFAULT_AUTH_SETTINGS);
    }
  );
}

export function isEmailDomainAllowed(email, allowedDomains) {
  if (!allowedDomains || allowedDomains.length === 0) return true;
  if (!email) return false;
  const at = email.lastIndexOf('@');
  if (at < 0) return false;
  const domain = email.slice(at + 1).toLowerCase();
  return allowedDomains.some((d) => d.toLowerCase() === domain);
}
